import { AppController } from '../controller/controller';
import { AppView } from '../view/appView';

export class App {
    public controller: AppController;
    public view: AppView;

    constructor() {
        this.controller = new AppController();
        this.view = new AppView();
    }

    public start(): void {
        const menu = document.querySelector('#menu-toggle') as HTMLInputElement;
        const sources = document.querySelector('.sources') as HTMLElement;
        sources.addEventListener('click', (e): void => {
            this.controller.getNews(e, (data): void => this.view.drawNews(data));
            menu.checked = false;
        });
        this.controller.getSources((data): void => this.view.drawSources(data));
    }
}